import { getAccount, selectAccount } from "app/redux/accountSlice";
import { getAppointmentGroupByBookingToken } from "app/redux/appointmentGroupSlice";
import { useQuery } from "app/utils/useQuery";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export enum DualPricingPaymentTypes {
  CASH = "cash",
  CARD = "card",
}

export const useBook = () => {
  const { nameKey } = useParams();
  const query = useQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const account = useSelector(selectAccount);
  const [showLocations, setShowLocations] = useState(false);
  const [shopHovered, setShopHovered] = useState(null);
  const [appointmentGroupToReschedule, setAppointmentGroupToReschedule] =
    useState<any>(null);

  const onBookNowClick = () => {
    setShowLocations(true);
  };

  useEffect(() => {
    if (!nameKey) return;
    (async () => {
      try {
        setIsLoading(true);
        await dispatch(getAccount({ nameKey }) as any).unwrap();
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        navigate("/");
        setIsLoading(false);
      }
      if (query.get("reschedule") === "true") {
        setShowLocations(true);
      }
      if (query.get("appointmentGroupToReschedule")) {
        try {
          const appointmentGroup = await dispatch(
            getAppointmentGroupByBookingToken({
              bookingToken: query.get("appointmentGroupToReschedule"),
            } as any) as any
          ).unwrap();
          if (appointmentGroup) {
            setShowLocations(true);
            setAppointmentGroupToReschedule(appointmentGroup);
          } else {
            navigate("/");
          }
        } catch (error) {
          console.error(error);
          navigate("/");
        }
      }
    })();
  }, []);

  return {
    showLocations,
    account,
    onBookNowClick,
    shopHovered,
    setShopHovered,
    navigate,
    isLoading,
    appointmentGroupToReschedule,
    query,
  };
};
